import { useTranslation } from "react-i18next"

import { MultiCombobox } from "@/components/ui/multi-combobox"
import { useFetchAllCampaignNames } from "@/pages/Campaigns/shared/campaign-queries"

import { LoadingFilter } from "../../Campaigns/pickers/generic-filter-picker"

type Props = {
  allowReset?: boolean
  onChange: (values: string[]) => void
  values: string[]
}

export function CampaignPicker({ allowReset, onChange, values }: Props) {
  const { t } = useTranslation()
  const { data, isLoading } = useFetchAllCampaignNames()

  if (isLoading) return <LoadingFilter />

  const options =
    data?.data.campaigns.map((campaign) => ({
      value: campaign.id,
      label: campaign.id,
    })) || []

  return (
    <MultiCombobox
      allowReset={allowReset}
      values={values}
      onChange={onChange}
      options={options}
      placeholder={t("callHistory.campaignsFilterPlaceholder")}
      size="lg"
    />
  )
}
